import type { WebEnv } from "../lib/env";
import { AuthProvider } from "../auth/AuthContext";
import { AppRouter } from "./router";

export function App({ env }: { env: WebEnv }) {
  return (
    <AuthProvider env={env}>
      <AppRouter />
    </AuthProvider>
  );
}
